<template>
  <div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      :width="width"
      :height="height"
      :viewBox="viewBox"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.8669 2.13947C17.0444 2.32544 17.0444 2.62694 16.8669 2.81291L8.09737 12L16.8669 21.1871C17.0444 21.3731 17.0444 21.6746 16.8669 21.8605C16.6894 22.0465 16.4016 22.0465 16.224 21.8605L7.13313 12.3367C6.95562 12.1508 6.95562 11.8492 7.13313 11.6633L16.224 2.13947C16.4016 1.95351 16.6894 1.95351 16.8669 2.13947Z"
        :fill="color"
      />
    </svg>
  </div>
</template>

<script>
  export default {
    props: {
      width: {
        type: [Number, String],
        default: 24,
      },
      height: {
        type: [Number, String],
        default: 24,
      },
      color: {
        type: String,
        default: 'currentColor',
      },
    },

    computed: {
      viewBox() {
        return `0 0 ${this.width} ${this.height}`
      },
    },
  }
</script>

<style lang="scss" scoped></style>
